// extracted by mini-css-extract-plugin
export default {"loginContainer":"Login_loginContainer__GfwOe","loginBox":"Login_loginBox__eEs38","registerButton":"Login_registerButton__YkNvm"};